(function() {
    $(document).ready(function() {
        $('a.zoom').on('click', function(e) {

            if (!$('#c24ImgOverlay').length) {
                $('body').append($('<div id="c24ImgOverlay"></div>'));
            }

            $('#c24ImgOverlay')
                .css({
                    backgroundImage: 'url(' + this.href + ')',
                })
                .addClass('open')
                .one('click', function() { $(this).removeClass('open'); });

            e.preventDefault();
        });
    });
})();
